import React from 'react'
import TextContent from '../../components/TextContent/TextContent'
import HeroBanner from '../../components/Common Banner Component/HeroBanner'

function NovaStarCE() {
  return (
    <div style={{background:"#022A44"}}>  
        <HeroBanner
            // Heading={"NovaStar Certified "}
            Heading={"Certified Engineers"}
          HighlightedSpan={""}
          spanHeadingBr={true}
          Paragraph={`The global LED wall and video engineering industry is experiencing rapid growth, with Novastar
Certified Engineers (NCE) representing a benchmark of advanced expertise.
Blue Fysh employs NCEs, professionals who serve and support clients at the cutting edge of
LED display and video engineering.`}
          bgImg={'/images/creatives/nsce-hero-bg.png'}
          beginingLogo="/images/icons/novastar-logo.png"
          isChevron={false}
          isBtn={false}
        />
        
        <TextContent
            preSpanHeading=""
            heading = "Enhanced Technical "
            spanHeading={"Expertise"}
            shiftRow={true}
            // content={"We support NovaStar products, including LED control systems, processors, and software such as LCT, VMP, and Taurus cloud-based solutions.\n Our engineers are trained to independently operate, maintain, and troubleshoot equipment, handling common faults, replacing parts, and optimizing performance, essential skills in the LED and video production industry.\n The certification combines both theoretical and hands-on training, equipping Blue Fysh engineers with the skills needed to set up any real-world scenario.\n They work across a wide range of screen sizes, from small-scale setups to massive installations."}
            content={"We support NovaStar products, including LED control systems, processors, and software such as LCT, VMP, and Taurus cloud-based solutions.\n Our engineers are trained to independently operate, maintain, and troubleshoot equipment, handling common faults, replacing parts, and optimizing performance, essential skills in the LED and video production industry.\n They work across a wide range of screen sizes, from Canada's largest convention centers to professional film studios with multi million dollar setups."}
            img={"/images/creatives/nsce-text-1.png"}
            mobileTextCenter={true}
            listPointList={false}
            btn={true}
            btnText={"Let's Connect"}
            btnRef="tel"
        />
        <TextContent
            preSpanHeading=""
            heading = "Global "
            spanHeading={"Technology"}
            shiftRow={false}
            content={"Since its launch in 2014, the NCE program has certified over 3,000 professionals globally, earning a strong reputation in the LED industry.\n However, access to qualified engineers can be limited, that’s where we come in.\n We not only install and deploy NovaStar technology but also provide ongoing maintenance and calibration to keep systems performing at their best."}
            img={"/images/creatives/nsce-text-2.png"}
            mobileTextCenter={true}
            listPointList={false}
            btn={true}
            btnText={"Let's Connect"}
            btnRef="tel"
        />
        <TextContent
            preSpanHeading=""
            heading = "Technological  "
            spanHeading={"Growth"}
            shiftRow={true}
            content={"As out-of-home (OOH) advertising continues to expand, the demand for innovative video solutions is increasing across various sectors.\n We provide comprehensive support for these technologies in diverse settings, including live events, broadcast studios, convention centers, storefronts, and digital signage installations.\n Our team ensures that every installation runs smoothly and efficiently, meeting the unique demands of each environment helping businesses stay ahead in an ever-evolving technological landscape."}
            img={"/images/creatives/nsce-text-3.png"}
            mobileTextCenter={true}
            listPointList={false}
            btn={true}
            btnText={"Let's Connect"}
            btnRef="tel"
        />
    
      </div>
  )
}

export default NovaStarCE